import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ContractDaysConfiguration  {
    _originalTypeClassName = "zERP.BO.ContractDaysConfiguration";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ContractDaysConfiguration.translate = translateService;
}
this.Id = null;
this.Day0Insured = false;
this.Day1Insured = false;
this.Day2Insured = false;
this.Day3Insured = false;
this.Day4Insured = false;
this.Day5Insured = false;
this.Day6Insured = false;
this.Day0Hours = null;
this.Day1Hours = null;
this.Day2Hours = null;
this.Day3Hours = null;
this.Day4Hours = null;
this.Day5Hours = null;
this.Day6Hours = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Day0Insured:any;
Day1Insured:any;
Day2Insured:any;
Day3Insured:any;
Day4Insured:any;
Day5Insured:any;
Day6Insured:any;
Day0Hours:any;
Day1Hours:any;
Day2Hours:any;
Day3Hours:any;
Day4Hours:any;
Day5Hours:any;
Day6Hours:any;

static IsUnsured($this: any, date: any): any{switch (moment(date).day()) {case 0:
{
return $this?.Day6Insured;}
case 1:
{
return $this?.Day0Insured;}
case 2:
{
return $this?.Day1Insured;}
case 3:
{
return $this?.Day2Insured;}
case 4:
{
return $this?.Day3Insured;}
case 5:
{
return $this?.Day4Insured;}
case 6:
{
return $this?.Day5Insured;}
}
return false;
}
static WorkingHours($this: any, date: any): any{return Domain.ContractDaysConfiguration.WorkingHoursByDayNumber($this, moment(date).day());
}
static WorkingHoursByDayNumber($this: any, number: any): any{switch (number) {case 0:
{
return $this?.Day6Hours;}
case 1:
{
return $this?.Day0Hours;}
case 2:
{
return $this?.Day1Hours;}
case 3:
{
return $this?.Day2Hours;}
case 4:
{
return $this?.Day3Hours;}
case 5:
{
return $this?.Day4Hours;}
case 6:
{
return $this?.Day5Hours;}
}
return 0;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}